import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import userPlaceholder from '../assets/img/user-6.jpg'

import { API_BASE } from '../utils/api'

interface DBAgent {
    _id: string; name: string; email: string; role: string; phone?: string;
    about?: string; city?: string; state?: string; avatar?: string;
}

export default function DetailSidebarTwo({ agent, propertyId, brochureUrl, legalDocUrl }: { agent?: DBAgent, propertyId: string, brochureUrl?: string, legalDocUrl?: string }) {
    const [activeTab, setActiveTab] = useState<number>(1)
    const [count1, setCount1] = useState<number>(1)
    const [submitting, setSubmitting] = useState(false)
    const [msg, setMsg] = useState<{ type: 'success' | 'error', text: string } | null>(null)

    // Form states
    const [bookingForm, setBookingForm] = useState({
        name: '', email: '', phone: '', date: '', time: '', message: ''
    })

    const handleInput = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setBookingForm(p => ({ ...p, [e.target.name]: e.target.value }))
    }

    const { token } = useAuth()

    const handleBooking = async (type: 'Site Visit' | 'Appointment') => {
        if (!bookingForm.name || !bookingForm.phone) {
            setMsg({ type: 'error', text: 'Name and Phone are required.' })
            return
        }
        setSubmitting(true); setMsg(null)
        try {
            const res = await fetch(`${API_BASE}/bookings`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    property: propertyId,
                    type,
                    name: bookingForm.name,
                    phone: bookingForm.phone,
                    email: bookingForm.email,
                    date: type === 'Site Visit' ? bookingForm.date : undefined,
                    time: type === 'Site Visit' ? bookingForm.time : undefined,
                    guests: type === 'Site Visit' ? count1 : 1,
                    message: bookingForm.message
                })
            })
            const data = await res.json()
            if (res.ok) {
                setMsg({ type: 'success', text: 'Inquiry submitted successfully!' })
                setBookingForm({ name: '', email: '', phone: '', date: '', time: '', message: '' })
            } else {
                setMsg({ type: 'error', text: data.message || 'Submission failed.' })
            }
        } catch (err) {
            setMsg({ type: 'error', text: 'Server error. Please try again.' })
        }
        setSubmitting(false)
    }

    const [salePrice, setSalePrice] = useState<string>('')
    // ... existing states for mortgage calculator ...
    const [downPayment, setDownPayment] = useState<string>('')
    const [loanTerm, setLoanTerm] = useState<string>('')
    const [interestRate, setInterestRate] = useState<string>('')
    const [monthlyPayment, setMonthlyPayment] = useState<number | null>(null)

    const increment = () => setCount1(p => p + 1)
    const decrement = () => setCount1(p => p > 1 ? p - 1 : 1)

    const calculateMortgage = () => {
        const P = parseFloat(salePrice) - (parseFloat(downPayment) || 0)
        const i = (parseFloat(interestRate) / 100) / 12
        const n = parseFloat(loanTerm) * 12

        if (isNaN(P) || isNaN(i) || isNaN(n) || P <= 0 || i <= 0 || n <= 0) {
            setMonthlyPayment(0)
            return
        }

        const M = P * (i * Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1)
        setMonthlyPayment(M)
    }

    return (
        <>
            <div className="sides-widget b-0 p-3 bg-white rounded shadow-sm mb-4">
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                        <Link to="#" className="btn-circle-alt" data-toggle="tooltip" data-original-title="Share"
                            style={{
                                width: '45px', height: '45px', borderRadius: '50%', backgroundColor: '#f0f2f5',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0a1f6e',
                                border: 'none', transition: 'all 0.3s'
                            }}>
                            <i className="fas fa-share-alt" style={{ fontSize: '18px' }}></i>
                        </Link>
                        <Link to="#" className="btn-circle-alt" data-toggle="tooltip" data-original-title="Save"
                            style={{
                                width: '45px', height: '45px', borderRadius: '50%', backgroundColor: '#f0f2f5',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0a1f6e',
                                border: 'none', transition: 'all 0.3s'
                            }}>
                            <i className="far fa-heart" style={{ fontSize: '18px' }}></i>
                        </Link>
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                        {brochureUrl && (
                            <a href={brochureUrl} target="_blank" rel="noreferrer" className="btn btn-primary d-flex align-items-center px-3 py-2 fw-bold"
                                style={{ borderRadius: '30px', fontSize: '12px', whiteSpace: 'nowrap' }}>
                                <i className="fas fa-download me-1"></i>Brochure
                            </a>
                        )}
                        {legalDocUrl && (
                            <a href={legalDocUrl} target="_blank" rel="noreferrer" className="btn btn-outline-primary d-flex align-items-center px-3 py-2 fw-bold"
                                style={{ borderRadius: '30px', fontSize: '12px', whiteSpace: 'nowrap' }}>
                                <i className="fas fa-file-contract me-1"></i>Legal Doc
                            </a>
                        )}
                    </div>
                </div>
            </div>

            <div className="property-sidebar side_stiky">

                <div className="sider_blocks_wrap">
                    <div className="side-booking-header">
                        <ul className="nav nav-pills sider_tab" id="pills-tab" role="tablist">
                            <li className="nav-item">
                                <Link className={`nav-link ${activeTab === 1 ? 'active' : ''}`} to="#" onClick={() => setActiveTab(1)}>Property Visit</Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`nav-link ${activeTab === 2 ? 'active' : ''}`} to="#" onClick={() => setActiveTab(2)}>Contact Us</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="sidetab-content">
                        {msg && <div className={`alert alert-${msg.type === 'success' ? 'success' : 'danger'} m-3 py-2 small fw-bold`}>{msg.text}</div>}
                        <div className="tab-content">
                            <div className={`tab-pane fade ${activeTab === 1 ? 'active show' : ''}`}>
                                <div className="side-booking-body">
                                    <div className="row g-2">
                                        <div className="col-12">
                                            <div className="form-group mb-2">
                                                <label className="small fw-bold">Full Name</label>
                                                <input type="text" name="name" className="form-control ps-3" placeholder="Your Name" value={bookingForm.name} onChange={handleInput} />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group mb-2">
                                                <label className="small fw-bold">Mobile Number</label>
                                                <input type="text" name="phone" className="form-control ps-3" placeholder="Mobile No." value={bookingForm.phone} onChange={handleInput} />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                            <div className="form-group mb-2">
                                                <label className="small fw-bold">Date</label>
                                                <div className="cld-box">
                                                    <input type="date" name="date" className="form-control ps-3" value={bookingForm.date} onChange={handleInput} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                            <div className="form-group mb-2">
                                                <label className="small fw-bold">Time</label>
                                                <div className="cld-box">
                                                    <input type="time" name="time" className="form-control ps-3" value={bookingForm.time} onChange={handleInput} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="form-group">
                                                <div className="guests">
                                                    <label className="small fw-bold">Total person</label>
                                                    <div className="guests-box">
                                                        <button className="counter-btn" type="button" onClick={decrement}><i className="fa-solid fa-minus"></i></button>
                                                        <input type="text" readOnly value={count1} />
                                                        <button className="counter-btn" type="button" onClick={increment}><i className="fa-solid fa-plus"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="stbooking-footer mt-1">
                                                <button type="button" className="btn btn-primary fw-medium full-width" onClick={() => handleBooking('Site Visit')} disabled={submitting}>
                                                    {submitting ? 'Submitting...' : 'Book Property Visit'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={`tab-pane fade ${activeTab === 2 ? 'active show' : ''}`}>
                                <div className="sider-block-body p-3">
                                    <div className="row g-2">
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="form-group mb-2">
                                                <label className="small fw-bold">Full Name</label>
                                                <input type="text" name="name" className="form-control ps-3" placeholder="Enter Name" value={bookingForm.name} onChange={handleInput} />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="form-group mb-2">
                                                <label className="small fw-bold">Email ID</label>
                                                <input type="email" name="email" className="form-control ps-3" placeholder="Enter Email" value={bookingForm.email} onChange={handleInput} />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="form-group mb-2">
                                                <label className="small fw-bold">Contact Number</label>
                                                <input type="text" name="phone" className="form-control ps-3" placeholder="Enter Phone No." value={bookingForm.phone} onChange={handleInput} />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="form-group mb-2">
                                                <label className="small fw-bold">Message</label>
                                                <textarea name="message" className="form-control ps-3" rows={2} placeholder="Explain Query" value={bookingForm.message} onChange={handleInput}></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="form-group">
                                                <button type="button" className="btn btn-primary fw-medium full-width" onClick={() => handleBooking('Appointment')} disabled={submitting}>
                                                    {submitting ? 'Submitting...' : 'Send Message'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sides-widget mt-4">

                    <div className="sides-widget-header bg-primary">
                        <div className="sides-widget-details">
                            <h4>Mortgage Calculator</h4>
                            <span>View your Interest Rate</span>
                        </div>
                        <div className="clearfix"></div>
                    </div>

                    <div className="sides-widget-body simple-form">
                        <div className="form-group">
                            <div className="input-with-icon">
                                <input type="number" className="form-control" placeholder="Sale Price" value={salePrice} onChange={(e) => setSalePrice(e.target.value)} />
                                <i className="fa-solid fa-sack-dollar"></i>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="input-with-icon">
                                <input type="number" className="form-control" placeholder="Down Payment" value={downPayment} onChange={(e) => setDownPayment(e.target.value)} />
                                <i className="fa-solid fa-piggy-bank"></i>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="input-with-icon">
                                <input type="number" className="form-control" placeholder="Loan Term (Years)" value={loanTerm} onChange={(e) => setLoanTerm(e.target.value)} />
                                <i className="fa-regular fa-calendar-days"></i>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="input-with-icon">
                                <input type="number" className="form-control" placeholder="Interest Rate (%)" value={interestRate} onChange={(e) => setInterestRate(e.target.value)} />
                                <i className="fa fa-percent"></i>
                            </div>
                        </div>

                        {monthlyPayment !== null && (
                            <div className="bg-light-primary p-3 rounded mb-3 text-center">
                                <span className="d-block small text-muted uppercase fw-bold mb-1">Estimated Monthly Payment</span>
                                <h4 className="mb-0 text-primary">₹ {monthlyPayment.toLocaleString(undefined, { maximumFractionDigits: 2 })}</h4>
                            </div>
                        )}

                        <button className="btn btn-primary fw-medium rounded full-width" onClick={calculateMortgage}>Calculate</button>
                    </div>
                </div>

                {agent && (
                    <div className="details-sidebar mt-4">
                        <div className="sides-widget">
                            <div className="sides-widget-header bg-primary">
                                <div className="agent-photo">
                                    <img
                                        src={agent?.role === 'admin' ? '/logo.png' : (agent?.avatar || userPlaceholder)}
                                        alt={agent?.role === 'admin' ? 'Mypropertyguru' : (agent?.name || 'Agent')}
                                        style={agent?.role === 'admin' ? { objectFit: 'contain', backgroundColor: '#fff', padding: '5px' } : {}}
                                    />
                                </div>
                                <div className="sides-widget-details">
                                    <h4>
                                        {agent?.role === 'admin' ? (
                                            <span className="text-white fw-bold">Mypropertyguru</span>
                                        ) : (
                                            <Link to={`/agent-page/${agent?._id}`}>{agent?.name || 'Contact Agent'}</Link>
                                        )}
                                    </h4>
                                    <span><i className="lni-phone-handset"></i>{agent?.role === 'admin' ? '9537002666' : (agent?.phone || '(+91) 123 456 7890')}</span>
                                </div>
                                <div className="clearfix"></div>
                            </div>

                            <div className="sides-widget-body simple-form">
                                <div className="form-group">
                                    <label>Email</label>
                                    <input type="text" className="form-control" placeholder="Your Email" />
                                </div>
                                <div className="form-group">
                                    <label>Phone No.</label>
                                    <input type="text" className="form-control" placeholder="Your Phone" />
                                </div>
                                <div className="form-group">
                                    <label>Description</label>
                                    <textarea className="form-control" defaultValue="I'm interested in this property."></textarea>
                                </div>
                                <button className="btn btn-light-primary fw-medium rounded full-width">Send Message</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
